/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * Indicates the field to use for sorting the data:
 *   * DATE : the date
 *   * TAG : the tag name
 *   * DESCRIPTION : the tag description
 *   * VALUE : the value
 */
export enum EventLogSortFieldName {
  DATE = 'DATE',
  TAG = 'TAG',
  DESCRIPTION = 'DESCRIPTION',
  VALUE = 'VALUE'
}
